import PropTypes from 'prop-types';

import { PaymentMethodWithSubmitProps } from './@types';

export const BillingDetailsDefaultPropTypes = {
  billingAddress1: PropTypes.string,
  billingAddress2: PropTypes.string,
  billingState: PropTypes.string,
  billingCity: PropTypes.string,
  billingZip: PropTypes.string,
  billingCountry: PropTypes.string,
  billingEmail: PropTypes.string,
  billingFirstName: PropTypes.string,
  billingLastName: PropTypes.string,
  billingName: PropTypes.string,
  billingBirthday: PropTypes.string,
  billingDocumentNumber: PropTypes.string,
  billingDocumentType: PropTypes.string,
  billingTaxId: PropTypes.string,
  billingCompany: PropTypes.string,
  billingPhone: PropTypes.string,
  billingFax: PropTypes.string,
};

export const CommonPaymentElementPropTypes = {
  lang: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onLoadStart: PropTypes.func,
  onLoadEnd: PropTypes.func,
  onError: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  isHostFormValid: PropTypes.bool,
  currentErrorOnly: PropTypes.bool,
  guest: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    billingDetails: PropTypes.shape(BillingDetailsDefaultPropTypes),
  }),
  // TODO: should not belong here
  slot: PropTypes.object,
};

export type CommonPaymentElementProps = PaymentMethodWithSubmitProps<typeof CommonPaymentElementPropTypes>;
